export default __webpack_public_path__ + "static/media/cashWhite.916568c4.svg";